import { Client } from "../../../types/src";

export function isPaidClient(client: Client): boolean {
  return (client.active && !client.trial_active);
}